/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FollowSearchButton_favoritesConnection$ref = any;
export type SbRespFollowSearchTopButton_user$ref = any;
export type SbRespFollowSearchTopButton_user = {
    readonly serviceId: string | null;
    readonly favorites: {
        readonly " $fragmentRefs": FollowSearchButton_favoritesConnection$ref;
    } | null;
    readonly " $refType": SbRespFollowSearchTopButton_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespFollowSearchTopButton_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "followSearchTypes",
            "type": "[types]"
        },
        {
            "kind": "RootArgument",
            "name": "followSearchPages",
            "type": "[String]"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "favorites",
            "storageKey": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                },
                {
                    "kind": "Variable",
                    "name": "pages",
                    "variableName": "followSearchPages"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "followSearchTypes"
                }
            ],
            "concreteType": "favoritesConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FollowSearchButton_favoritesConnection",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'a3c6a58e43da1f5d7cdfe1744df9c8d1';
export default node;
